import {
  call,
  ForkEffect,
  put,
  putResolve,
  takeLeading,
} from "redux-saga/effects";
import {
  HEALTH_CHECK,
  ISubscribeNotificationForbidden,
  ISubscribeUserMobileDeviceRequest,
  IUnSubscribeUserMobileDeviceRequest,
} from "../../redux/healthCheck/types";

import {
  notifyLoginLogoutFailure,
  notifyLoginLogoutSuccess,
  subscribeNotifFailure,
  subscribeNotifSuccess,
  subscribeUserMobileDeviceAsTagFailure,
  subscribeUserMobileDeviceAsTagSuccess,
  unsubscribeNotifFailure,
  unsubscribeNotifSuccess,
  unsubscribeUserMobileDeviceAsTagFailure,
  unsubscribeUserMobileDeviceAsTagSuccess,
  updateSubscribeNotifFailure,
  updateSubscribeNotifSuccess,
} from "../../redux/healthCheck/actions";
import {
  INotifyLoginLogoutRequest,
  IRESubscribeNotification,
  ISubscribeNotification,
  IUnSubscribeNotification,
} from "../../redux/healthCheck/types";
import { AxiosCustom } from "../../service/Axios";
export function* subscribeWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(HEALTH_CHECK.SUBSCRIBE_NOTIFICATION_REQUEST, subscribeSaga);
}

function* subscribeSaga(action: ISubscribeNotification) {
  try {
    try {
      console.log("checkIFsubscribeSaga");
      const result = yield call(() =>
        AxiosCustom.checkNotification(action.payload.mobileId)
      );
      const {
        mobile_id,
        service_token_type,
        service_token,
        device_type,
        debug_mode,
        metadata,
        nodes,
      } = result.data;

      if (
        service_token_type !== action.payload.serviceTokenType ||
        service_token !== action.payload.serviceToken
      ) {
        yield call(() => AxiosCustom.registerNotification(action.payload));
        yield put(subscribeNotifSuccess(action.payload));
      } else {
        yield put(
          subscribeNotifSuccess({
            debugMode: debug_mode,
            deviceType: device_type,
            metadata: metadata,
            mobileId: mobile_id,
            serviceToken: service_token,
            serviceTokenType: service_token_type,
            nodeIds: nodes?.map((el) => el?.node_id),
          })
        );
      }
      return;
    } catch (error) {
      if (error?.response?.status === 404) {
        yield call(() => AxiosCustom.registerNotification(action.payload));
        yield put(subscribeNotifSuccess(action.payload));
      } else {
        if (error?.response?.status === 500)
          yield put(subscribeNotifFailure(undefined));

        console.log(error?.error || ": " + error?.errorDescription);
      }
    }

    return;
  } catch (error) {
    console.log("subscribeSaga", action.payload);
    yield putResolve(subscribeNotifFailure(action.payload));
  }
}
export function* unsubscribeWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(
    HEALTH_CHECK.UN_SUBSCRIBE_NOTIFICATION_REQUEST,
    unsubscribeSaga
  );
}

export function* unsubscribeSaga(action: IUnSubscribeNotification) {
  try {
    yield call(() => AxiosCustom.checkNotification(action.payload.mobileId));
    yield call(() => AxiosCustom.unregisterNotification(action.payload));
    yield put(unsubscribeNotifSuccess(action.payload));
    console.log("unsubscribeSaga success");
    return;
  } catch (error) {
    if (error?.response?.status === 404) return;
    console.log(
      "unsubscribeSaga fail " +
        error?.response?.status +
        " " +
        error?.response?.message
    );
    yield putResolve(unsubscribeNotifFailure(action.payload));
  }
}

export function* updateSubscribeWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(
    HEALTH_CHECK.RE_SUBSCRIBE_NOTIFICATION_REQUEST,
    updateSubscribeSaga
  );
}

function* updateSubscribeSaga(action: IRESubscribeNotification) {
  try {
    if (action.payload === undefined || action.payload.mobileId === undefined)
      return;
    yield call(() => AxiosCustom.updateNotification(action.payload));
    yield put(updateSubscribeNotifSuccess(action.payload));
    return;
  } catch (error) {
    console.log("updateSubscribeNotifFailure", action.payload);
    yield putResolve(updateSubscribeNotifFailure(action.payload));
    // yield call(ErrorMonitor, e, ErrorMessages.UPDATE_SUBSCRIBE);
  }
}

export function* cleanIfForbiddenSubscribeWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(
    HEALTH_CHECK.SUBSCRIBE_NOTIFICATION_FORBIDDEN,
    cleanIfForbiddenSubscribeSaga
  );
}

function* cleanIfForbiddenSubscribeSaga(
  action: ISubscribeNotificationForbidden
) {
  try {
    if (action.payload === "") return;
    const result = yield call(() =>
      AxiosCustom.checkNotification(action.payload)
    );
    if (result)
      yield call(() =>
        AxiosCustom.unregisterNotification({ mobileId: action.payload })
      );
    return;
  } catch (error) {
    console.log("cleanIfForbiddenSubscribeSaga", action.payload);
  }
}

export function* notifyLoginLogoutWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(
    HEALTH_CHECK.NOTIFY_LOGIN_LOGOUT_REQUEST,
    notifyLoginLogoutSaga
  );
}

export function* notifyLoginLogoutSaga(action: INotifyLoginLogoutRequest) {
  try {
    const { isLogin, value } = action.payload;
    if (isLogin) yield call(() => AxiosCustom.notifyLogin(value));
    else yield call(() => AxiosCustom.notifyLogout(value));
    yield put(notifyLoginLogoutSuccess(action.payload.isLogin));
    console.log("notify success " + isLogin);
    return;
  } catch (error) {
    if (error?.response?.status === 404) return;
    console.log(
      "notify fail " + error?.response?.status + " " + error?.response?.message
    );
    // yield put(snackBarError(error?.error || '' + ': ' + error?.errorDescription));
    yield putResolve(notifyLoginLogoutFailure(action.payload));
  }
}

export function* registerMobileDeviceAsTagWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(
    HEALTH_CHECK.SUBSCRIBE_USER_MOBILE_DEVICE_REQUEST,
    registerMobileDeviceAsTagSaga
  );
}

export function* registerMobileDeviceAsTagSaga(
  action: ISubscribeUserMobileDeviceRequest
) {
  try {
    console.log(
      "try to connect mobileDevice as tag" + JSON.stringify(action.payload)
    );
    const setUserTag =
      // eslint-disable-next-line no-new-func
      Function(`if (typeof Android !== 'undefined' && typeof Android.setUserTag !== 'undefined')
        Android.setUserTag(true);`);
    setUserTag();
    yield call(() => AxiosCustom.registerUserMobileDevices(action.payload));
    yield put(subscribeUserMobileDeviceAsTagSuccess(action.payload));
    console.log("registerMobileDeviceAsTagSaga success");
    return;
  } catch (error) {
    if (error?.response?.status === 404) return;
    console.log(
      "registerMobileDeviceAsTagSaga fail " + JSON.stringify(error.response)
    );
    yield putResolve(subscribeUserMobileDeviceAsTagFailure(action.payload));
  }
}

export function* unregisterMobileDeviceAsTagWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(
    HEALTH_CHECK.UNSUBSCRIBE_USER_MOBILE_DEVICE_REQUEST,
    registerMobileDeviceAsTagSaga
  );
}

export function* unregisterMobileDeviceAsTagSaga(
  action: IUnSubscribeUserMobileDeviceRequest
) {
  try {
    console.log("unregisterMobileDeviceAsTagSaga", action.payload);
    const setUserTag =
      // eslint-disable-next-line no-new-func
      Function(`if (typeof Android !== 'undefined' && typeof Android.setUserTag !== 'undefined')
        Android.setUserTag(true);`); //Android.setUserTag(false)
    setUserTag();
    yield call(() => AxiosCustom.unregisterUserMobileDevices(action.payload));
    yield put(unsubscribeUserMobileDeviceAsTagSuccess(action.payload));
    console.log("unregisterMobileDeviceAsTagSaga success");
    return;
  } catch (error) {
    if (error?.response?.status === 404) return;
    console.log(
      "unregisterMobileDeviceAsTagSaga fail " +
        error?.response?.status +
        " " +
        JSON.stringify(error?.response?.data)
    );
    yield putResolve(unsubscribeUserMobileDeviceAsTagFailure(action.payload));
  }
}
